import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Box, Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
import '../styles/MobileNavBar.css';

// استيراد الأيقونات
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FolderIcon from '@mui/icons-material/Folder';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'; // استيراد أيقونة الخدمات

// تنسيق مخصص لشريط التنقل
const StyledBottomNavigation = styled(BottomNavigation)(({ theme }) => ({
  backgroundColor: '#067ed4',
  boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
  '& .MuiBottomNavigationAction-root': {
    color: '#010636',
    '&.Mui-selected': {
      color: '#0596DE',
    },
    // تخصيص لون أيقونة الرئيسية عند الاختيار
    '&.home-icon.Mui-selected': {
      color: '#000000', // اللون الأسود
    },
  },
}));

// تنسيق مخصص لأزرار التنقل
const StyledBottomNavigationAction = styled(BottomNavigationAction)(({ theme }) => ({
  minWidth: 'auto',
  padding: '6px 0',
  '& .MuiBottomNavigationAction-label': {
    fontSize: '0.75rem',
    '&.Mui-selected': {
      fontSize: '0.75rem',
    },
  },
}));

const MobileNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [scrollPos, setScrollPos] = useState(0);
  const [hasAppointments] = useState(false);
  
  // تحديد القيمة الحالية بناءً على المسار
  const getCurrentValue = () => {
    const path = location.pathname;
    if (path === '/') return 0;
    if (path.includes('/dashboard') || path.includes('/profile')) return 1;
    if (path.includes('/appointments') || path.includes('/mobile-appointments')) return 2;
    if (path.includes('/documents') || path.includes('/mobile-documents')) return 3;
    if (path.includes('/services')) return 4; // إضافة مسار الخدمات
    return 0; // الافتراضي هو الصفحة الرئيسية
  };

  // التعامل مع حدث التمرير لإخفاء/إظهار شريط التنقل
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isVisible = scrollPos > currentScrollPos || currentScrollPos < 10;
      
      setScrollPos(currentScrollPos);
      setVisible(isVisible);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollPos]);

  const handleChange = (event, newValue) => {
    switch (newValue) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/provider/dashboard');
        break;
      case 2:
        navigate('/mobile-appointments');
        break;
      case 3:
        navigate('/mobile-documents');
        break;
      case 4:
        navigate('/services'); // التنقل إلى صفحة الخدمات
        break;
      default:
        navigate('/');
    }
  };

  return (
    <Box sx={{
      display: { xs: 'block', sm: 'none' }, // عرض فقط على الشاشات الصغيرة
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      transition: 'transform 0.3s ease-in-out',
      transform: visible ? 'translateY(0)' : 'translateY(100%)',
    }} className={`mobile-nav-bar ${visible ? '' : 'hidden'}`}>
      <StyledBottomNavigation
        value={getCurrentValue()}
        onChange={handleChange}
        showLabels
      >
        <StyledBottomNavigationAction 
          label="الرئيسية" 
          icon={<HomeIcon className={`mobile-nav-icon ${getCurrentValue() === 0 ? 'active' : ''}`} />} 
          className={`mobile-nav-action ${getCurrentValue() === 0 ? 'home-icon' : ''}`}
        />
        <StyledBottomNavigationAction 
          label="لوحة التحكم" 
          icon={<DashboardIcon className={`mobile-nav-icon ${getCurrentValue() === 1 ? 'active' : ''}`} />} 
          className="mobile-nav-action"
        />
        <StyledBottomNavigationAction 
          label="المواعيد" 
          icon={
            hasAppointments ? (
              <Badge badgeContent={<span className="notification-badge">!</span>} color="error">
                <CalendarTodayIcon className={`mobile-nav-icon ${getCurrentValue() === 2 ? 'active' : ''}`} />
              </Badge>
            ) : (
              <CalendarTodayIcon className={`mobile-nav-icon ${getCurrentValue() === 2 ? 'active' : ''}`} />
            )
          } 
          className="mobile-nav-action"
        />
        <StyledBottomNavigationAction 
          label="الوثائق" 
          icon={<FolderIcon className={`mobile-nav-icon ${getCurrentValue() === 3 ? 'active' : ''}`} />} 
          className="mobile-nav-action"
        />
        <StyledBottomNavigationAction 
          label="الخدمات" 
          icon={<MedicalServicesIcon className={`mobile-nav-icon ${getCurrentValue() === 4 ? 'active' : ''}`} />} 
          className="mobile-nav-action"
        />
      </StyledBottomNavigation>
    </Box>
  );
};

export default MobileNavBar;